import { render, staticRenderFns } from "./DigitalWalletScan.vue?vue&type=template&id=f071f3d6"
import script from "./DigitalWalletScan.vue?vue&type=script&lang=js"
export * from "./DigitalWalletScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports